
export default function scrolled(scrollThreshold = 50) {
  const body = document.body;
  const scrollClass = 'scrolled';
  let ticking = false;

  function updateScrollState() {
    if (window.scrollY >= scrollThreshold) {
      body.classList.add(scrollClass);
    } else {
      body.classList.remove(scrollClass);
    }
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateScrollState();
        ticking = false;
      });
      ticking = true;
    }
  });
}
